export const ALLOWED_SYMBOLS_PATTERN = {
  pattern: /^[\w\d\s:&-]+$/,
  message: 'This symbol is not allowed',
};
